import { initialState } from "reducers/TemplatesHistory/State";
import { TemplatesHistory } from "constants/Actions";
import _, { isArray } from "lodash";
import { updateTemplateList } from "functions/TemplateHistory";
import { DocumentType } from "constants/TemplateEditor";
import { groupByGroupId } from "functions";

const {
  GET_TEMPLATES,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAIL,
  GET_TEMPLATE_DATA,
  GET_TEMPLATE_DATA_SUCCESS,
  GET_TEMPLATE_DATA_FAIL,
  INIT_TEMPLATES,
  ADD_NEW_PAGE,
  DELETE_PAGE,
  GET_DOCUMENT_TYPES,
  GET_DOCUMENT_TYPES_SUCCESS,
  GET_DOCUMENT_TYPES_FAIL,
  IMPORT_TEMPLATE_DATA,
  SET_PAGE_PROPERTIES,
  UPDATE_TEMPLATE_DATA,

  SAVE_TEMPLATE_DATA,
  SAVE_TEMPLATE_DATA_SUCCESS,
  SAVE_TEMPLATE_DATA_FAIL,

  FILTER_TEMPLATES,
  COPY_TEMPLATE,
  COPY_TEMPLATE_SUCCESS,
  COPY_TEMPLATE_FAIL,
  COPY_TEMPLATE_COMPLETED,

  HANDLE_CONFIRM_EXIT_MODAL,
  SELECT_TEMPLATE,

  SORT_TEMPLATES,

  GET_TEMPLATE_VERSIONS_HISTORY,
  GET_TEMPLATE_VERSIONS_HISTORY_SUCCESS,
  GET_TEMPLATE_VERSIONS_HISTORY_FAIL,

  RESET_TEMPLATE_VERSIONS_HISTORY,
} = TemplatesHistory;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case INIT_TEMPLATES:
      return Object.assign({}, state, {
        templates: {
          data: [],
          groups: [],
          loading: true,
        },
        categories: {
          data: [],
          loading: true,
        },
      });
    case GET_DOCUMENT_TYPES:
      return Object.assign({}, state, {
        documentTypes: {
          data: [],
          loading: true,
        },
      });
    case GET_DOCUMENT_TYPES_SUCCESS:
      return Object.assign({}, state, {
        documentTypes: {
          data: isArray(payload.data)
            ? payload.data.filter(
                (item: any) => item.channelCode != DocumentType.EHF
              )
            : [],
          loading: false,
        },
      });
    case GET_DOCUMENT_TYPES_FAIL:
      return Object.assign({}, state, {
        documentTypes: {
          ...state.documentTypes,
        },
      });
    case GET_TEMPLATES:
      return Object.assign({}, state, {
        templates: {
          data: [],
          groups: [],
          loading: true,
        },
      });
    case GET_TEMPLATES_SUCCESS:
      return Object.assign({}, state, {
        templates: {
          data: payload.data.templates,
          groups: payload.data.groups,
          loading: false,
        },
      });
    case GET_TEMPLATES_FAIL:
      return Object.assign({}, state, {
        templates: {
          ...state.templates,
        },
      });
    case FILTER_TEMPLATES:
      return Object.assign({}, state, {
        templates: {
          ...state.templates,
          groups: payload.data,
        },
      });
    case SORT_TEMPLATES:
      return Object.assign({}, state, {
        templates: {
          ...state.templates,
          groups: groupByGroupId(payload.data),
        },
      });
    case SELECT_TEMPLATE:
      return Object.assign({}, state, {
        selectedTemplateId: payload.data.templateId,
      });
    case GET_TEMPLATE_DATA:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: {},
          loading: true,
        },
        confirmExitModal: initialState.confirmExitModal,
      });
    case GET_TEMPLATE_DATA_SUCCESS:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: payload.data,
          newTemplateId: Number(payload?.data?.templateId),
          loading: false,
        },
        initTemplate: { ...state.initTemplate, data: payload.data },
      });

    case GET_TEMPLATE_DATA_FAIL:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: payload.data,
          loading: false,
        },
        initTemplate: { data: payload.data },
      });
    case IMPORT_TEMPLATE_DATA:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: payload.data,
          loading: false,
        },
        initTemplate: { data: payload.data },
      });
    case SET_PAGE_PROPERTIES:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: {
            ...state.template.data,
            ...payload.data,
          },
          newTemplateId: -1,
          isSaveAs: false,
        },
      });
    case ADD_NEW_PAGE:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: {
            ...state.template.data,
            templateContent: {
              ...state.template.data.templateContent,
              pages: [
                ...state.template.data?.templateContent.pages,
                { sections: [] },
              ],
            },
          },
          isSaveAs: false,
        },
      });
    case DELETE_PAGE:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: {
            ...state.template.data,
            templateContent: {
              ...state.template.data.templateContent,
              pages: [
                ...state.template.data?.templateContent.pages?.filter(
                  (page: any, index: number) =>
                    index !== payload?.data?.pageIndex
                ),
              ],
            },
          },
          newTemplateId: -1,
          isSaveAs: false,
        },
      });
    case UPDATE_TEMPLATE_DATA:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: {
            ...state.template.data,
            ...payload.data,
          },
          loading: false,
        },
      });
    case SAVE_TEMPLATE_DATA:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          newTemplateId: -1,
          isSaveAs: false,
          saving: true,
        },
        initTemplate: {
          ...state.initTemplate,
          saving: true,
        },
      });
    case SAVE_TEMPLATE_DATA_SUCCESS:
      const templateId = Number(payload?.data?.templateId);
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: {
            ...state.template?.data,
            templateId: templateId,
            templateContent: {
              ...payload.data?.saveParams?.templateContent,
              templateId: templateId,
              versionNo:
                payload.data?.saveParams?.templateContent?.versionNo == 1
                  ? 2
                  : payload.data?.saveParams?.templateContent?.versionNo,
            },
          },
          newTemplateId: templateId,
          isSaveAs: payload?.data?.isSaveAs,
          saving: false,
        },
        initTemplate: {
          ...state.initTemplate,
          saving: false,
        },
        confirmExitModal: {
          ...state.confirmExitModal,
          visible: false,
        },
        selectedTemplateId: templateId,
        templates: {
          ...state.templates,
          data: updateTemplateList(state.templates.data, state.template.data),
        },
      });

    case SAVE_TEMPLATE_DATA_FAIL:
      return Object.assign({}, state, {
        template: {
          ...state.template,
          data: {
            ...state.template?.data,
            templateContent: {
              ...payload.error?.saveParams?.templateContent,
              versionNo: -1,
            },
          },
          newTemplateId: -1,
          isSaveAs: false,
          saving: false,
        },
        initTemplate: {
          ...state.initTemplate,
          saving: false,
        },
      });
    case COPY_TEMPLATE:
      return Object.assign({}, state, {
        templateCopy: {
          data: null,
          loading: true,
          completed: false,
        },
      });
    case COPY_TEMPLATE_SUCCESS:
      return Object.assign({}, state, {
        templateCopy: {
          data: {
            ...payload.data,
            templateId: 0,
            templateName: payload.data.templateName + " Copy",
            templateContent: {
              ...payload.data.templateContent,
              id: 0,
              templateId: 0,
              templateName: payload.data.templateName + " Copy",
              versionNo: -1,
            },
          },
          loading: false,
        },
      });
    case COPY_TEMPLATE_FAIL:
      return Object.assign({}, state, {
        templateCopy: {
          data: null,
          loading: false,
        },
      });
    case COPY_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        templateCopy: {
          ...state.templateCopy,
          completed: true,
        },
      });
    case HANDLE_CONFIRM_EXIT_MODAL:
      return Object.assign({}, state, {
        confirmExitModal: {
          ...payload.data,
        },
      });
    case GET_TEMPLATE_VERSIONS_HISTORY:
      return Object.assign({}, state, {
        templateVersions: {
          data: [],
          loading: true,
        },
      });
    case GET_TEMPLATE_VERSIONS_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        templateVersions: {
          data: payload.data,
          loading: false,
        },
      });
    case GET_TEMPLATE_VERSIONS_HISTORY_FAIL:
      return Object.assign({}, state, {
        templateVersions: {
          ...state.templateVersions,
          loading: false,
        },
      });
    case RESET_TEMPLATE_VERSIONS_HISTORY:
      return Object.assign({}, state, {
        templateVersions: {
          data: [],
          loading: false,
        },
      });
    default:
      return state;
  }
};
